export default {
  'Text': '문자',
  'Styles': '스타일',
  'Text here': '여기에 문자 입력해 주세요.',
  'Add subtitles': '텍스트  추가',
  'Text Color': '텍스트 색상',
  'Outline': '개요',
  'Background': '배경',
  'Position': '위치',
}